module.exports = __webpack_public_path__ + "static/startup1-b39ed67e41c53c461ac839aa09390ac2.mp4";